import React from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { buildWhatsAppUrl, openWhatsApp } from '../lib/whatsapp';

// Routes where the floating button should be hidden entirely
const HIDDEN_ROUTES = ['/notfall', '/admin'];

export default function WhatsAppButton() {
  const location = useLocation();
  const path = location.pathname || '/';
  if (HIDDEN_ROUTES.some((p) => path === p || path.startsWith(p + '/'))) return null;

  const text = 'Hallo UnfallHeld, ich brauche Unterstützung nach einem Unfall.';
  const href = buildWhatsAppUrl(text);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => { e.preventDefault(); openWhatsApp(text); }}
      data-testid="whatsapp-floating-button"
      aria-label="WhatsApp Kontakt"
      className="fixed bottom-5 right-5 z-50 hidden md:inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-3 pr-4 py-3 uh-shadow-lg hover:opacity-95 transition-opacity"
      style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
    >
      <MessageCircle className="h-5 w-5" />
      <span className="text-sm font-medium">WhatsApp</span>
    </a>
  );
}

